<script>
  import { factorKey } from './stores.js';

  function switchFactor(factor) {
    // console.log(factor);
    factorKey.set(factor);
    // highlightFacilityId.set(null);
  }

  let showFactors = true;

  function toggleFilters() {
    const fl = document.querySelector('#factorList');
    // console.log(fl, fl.classList.contains('dn'));
    if (fl.classList.contains('dn')) {
      fl.classList.remove('dn');
      fl.classList.add('db');
    } else {
      fl.classList.add('dn');
      fl.classList.remove('db');
    }
  }
</script>

<!-- climate factors -->
<div
  class="absolute top-0 right-0 z-999 tr dib dn-ns"
  style="margin-top: 1.25rem; margin-right: 0.5rem; width: 63px"
>
  <div
    class="pa2 right-bg white TIExBold pointer dib"
    on:click={() => {
      // console.log('click');
      // console.log(toggleFilters);
      toggleFilters();
    }}
  >
    FILTER
  </div>
  <ul
    class="tl list pv0 ph3 ma0 white ttu right-bg dn fr TI"
    style="width: 180px"
    id="factorList"
  >
    <li
      class="pt2 pb1 flex items-center pointer"
      on:click={switchFactor.bind(null, 'heat_risk_rating')}
    >
      <div
        class="dib mr2 off-filter flex items-center justify-center"
        style="background-color: #DD2E2A"
      >
        <div
          class="bg-black h1 w1 br-100 {$factorKey === 'heat_risk_rating'
            ? 'vis'
            : 'hidden'}"
        />
      </div>
      Heat Risk
    </li>
    <li
      class="pv1 flex items-center pointer"
      on:click={switchFactor.bind(null, 'wildfire_risk_rating')}
    >
      <div
        class="dib mr2 off-filter flex items-center justify-center"
        style="background-color: #FFB800"
      >
        <div
          class="bg-black br-100 h1 w1 {$factorKey === 'wildfire_risk_rating'
            ? 'vis'
            : 'hidden'}"
        />
      </div>
      Wildfire Risk
    </li>
    <li
      class="pb2 pt1 flex items-center pointer"
      on:click={switchFactor.bind(null, 'flood_risk_rating')}
    >
      <div
        class="dib mr2 off-filter flex items-center justify-center"
        style="background-color: #4492F7"
      >
        <div
          class="bg-black br-100 h1 w1 {$factorKey === 'flood_risk_rating'
            ? 'vis'
            : 'hidden'}"
        />
      </div>
      Flood Risk
    </li>
  </ul>
</div>

<!-- climate factors -->
<style>
</style>
